
export class RegisterDeviceModel {
  userId: string;
  deviceId: string|null;
  deviceName: string;
}
